export const LOGOUT = "Logout";
export const INITIATE_LOGIN = "Initiate Login";
export const CHECK_IF_LOGGED_IN = 'Check If Logged In';
export const REQUEST_CURRENT_STATE = "Request Current State";
export const LOGIN = "Login";
export const LOGIN_SUCCESS = "Login Success";
export const VERIFICATION_SUCCESS = 'Verification Success';
export const VERIFY_LOGIN = "Verify Login";
export const SAVE_TOKEN = "Save Token";
export const SET_NEW_TOKEN = "SET_NEW_TOKEN";
